import React, { FC } from "react";
import { CardContent, CardHeader, Typography } from "@mui/material";
import {
  addressCardHeader,
  addressTextStyle1,
  addressTextStyle2,
  addressTextStyle3,
  addressTextStyle4,
  headerBorderBottom,
} from "./orderDetailsStyles";
import { Address } from "../../dto/orderSummaryTypes";
import useIsMobile from "../mobileVersion/useIsMobile";

export const AddressHeader: FC<{ title: string }> = ({ title }) => {
  const isMobile = useIsMobile();
  return (
    <CardHeader
      title={<Typography sx={addressCardHeader}>{title}</Typography>}
      sx={!isMobile ? headerBorderBottom : { pb: "4px" }}
    />
  );
};

export const AddressBody: FC<Address> = ({ name, address, email, phone }) => {
  const fields = [
    {
      title: name,
      style: addressTextStyle1,
    },
    {
      title: address,
      style: addressTextStyle2,
    },
    {
      title: "Email",
      style: addressTextStyle3,
    },
    {
      title: email,
      style: addressTextStyle4,
    },
    {
      title: "Phone",
      style: addressTextStyle3,
    },
    {
      title: phone,
      style: addressTextStyle4,
    },
  ];

  return (
    <CardContent
      sx={{
        pt: { xs: 0, sm: "16px" },
        "&:last-child": {
          paddingBottom: { xs: 0, sm: "24px" }, // Remove padding bottom from last child in mobile view
        },
      }}
    >
      {fields.map((field, idx) => (
        <Typography key={idx} sx={field.style}>
          {field.title}
        </Typography>
      ))}
    </CardContent>
  );
};
